import type { ListTableLazyHandlerWrapperProps } from "./list-table-lazy-handler.type";

import { useListContext } from "@/modules/list";

import ListTableLazyHandler from "./list-table-lazy-handler.component";

const ListTableLazyHandlerWrapper = (
  props: ListTableLazyHandlerWrapperProps
) => {
  const { lazy } = useListContext();

  if (!lazy) return null;

  return <ListTableLazyHandler lazyOptions={lazy} {...props} />;
};

export default ListTableLazyHandlerWrapper;
